"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _default = function _default(theme) {
  return {
    root: {},
    Label: {
      width: 153,
      marginRight: 17,
      padding: '6px 0'
    },
    error: (0, _extends2.default)({}, theme.typography.smallText, {
      position: 'absolute',
      lineHeight: '20px',
      bottom: -21,
      color: theme.colors.red
    }),
    formControl: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      width: 290,
      padding: '5px 0',
      cursor: 'pointer'
    },
    isFullWidth: {
      width: '100%'
    },
    checkboxControl: {
      display: 'flex',
      alignItems: 'center',
      lineHeight: '20px',
      marginBottom: 14
    },
    checkboxLabel: (0, _extends2.default)({
      marginLeft: 10
    }, theme.typography.defaultText, {
      color: theme.colors.greySoft
    }),
    isReadOnly: {
      '& $formControl': {
        cursor: 'not-allowed',
        '&::before': {
          borderBottom: "1px solid ".concat(theme.colors.lines)
        },
        '&::after': {
          borderBottom: "1px solid ".concat(theme.colors.lines)
        }
      }
    },
    vertical: {
      display: 'block',
      padding: '12px 0 11px 0',
      marginLeft: '0 !important',
      '& $formControl': {
        marginTop: 10
      }
    },
    horizontal: {
      display: 'flex',
      alignItems: 'flex-start',
      padding: '12px 0 11px 0'
    }
  };
};

exports.default = _default;